export default __webpack_public_path__ + "static/media/bin.a471b638.svg";